import React from 'react';
import styled from 'styled-components';
import { FormError } from '/imports/ui/FormError';
import { css } from '/imports/ui/css';

const FormFieldStyled = styled.div`
  position: relative;
  label {
  }
  &.checkbox {
    margin-top: auto;
    label {
      display: flex;
    }
  }
  &.error {
    input, select, textarea {
      border: 2px solid ${css.red2};
      color: ${css.red2};
      outline: none;
    }
  }
  .optional {
    margin-left: 0.25rem;
    text-transform: lowercase;
  }
  .asterisk {
    color: ${css.red2};
  }
  .field-tip {
    position: relative;
    top: -0.15rem;
    left: 0;
    margin-left: 0.25rem;
    svg {
      width: 1.25rem;
      height: 1.25rem;
      * {
        fill: ${css.black};
      }
    }
  }
`;

interface FormFieldProps {
  id?: string;
  className?: string;
  field: string;
  error?: any;
  children: React.ReactNode;
}

/** Form field wrapper that renders children and any validation error. */
export const FormField = (props: FormFieldProps) => {
  const { id, field, error, children, className } = props;
  const hasError = !!error?.[field]?.[0];
  return (
    <FormFieldStyled id={id} className={`field${hasError ? ' error' : ''}${className ? ` ${className}` : ''}`}>
      {children}
      <FormError field={field} error={error} />
    </FormFieldStyled>
  );
};